import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d5ce871"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "card mb-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "質問", -1))
const _hoisted_4 = { class: "card-body p-3" }
const _hoisted_5 = { class: "form-check form-check-inline" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "true",
  class: "form-check-label"
}, "質問あり", -1))
const _hoisted_7 = { class: "form-check form-check-inline" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "false",
  class: "form-check-label"
}, "質問なし", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "table table-hover table-bordered" }
const _hoisted_11 = { class: "table-secondary" }
const _hoisted_12 = { colspan: "2" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  type: "button",
  class: "btn btn-sm btn-secondary me-2 handle"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-auto" }, "手続き", -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light col-3" }, [
  /*#__PURE__*/_createTextVNode("結果表示条件"),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger float-end" }, "必須")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light col-3" }, [
  /*#__PURE__*/_createTextVNode("手続き対象"),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger float-end" }, "必須")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light" }, "手続き種別", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light" }, "持ち物", -1))
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light" }, "その他の手続き可能な窓口", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light" }, "窓口補足", -1))
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light" }, "関連リンク", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light" }, "電子申請", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "リンク", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "補足", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-light" }, "備考", -1))
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 手続きを追加する ")
const _hoisted_42 = { class: "d-flex justify-content-center my-2" }

import { computed, reactive, ref, unref, watch } from 'vue'
import { useNicotto, ConciergeQuestion, ConciergeQuestionProcess } from '@/plugins/nicotto'
import InputSkipSection from "@/components/ui/InputSkipSection.vue"
import IconUpDownLeftRight from "@/components/ui/IconUpDownLeftRight.vue"
import FormGroup from "@/components/ui/FormGroup.vue"
import InputText from "@/components/ui/InputText.vue"
import InputTextArea from "@/components/ui/InputTextArea.vue"
import ModalWindow from "@/components/ModalWindow.vue"
import IconPlus from "@/components/ui/IconPlus.vue"
import IconMinus from "@/components/ui/IconMinus.vue"
import draggable from 'vuedraggable'
import ModalQuestion from "@/components/ModalQuestion.vue";
import {useValidateForm} from "@/components/ui/validator";
import ButtonDelete from "@/components/ui/ButtonDelete.vue";
import IconCirclePlus from "@/components/ui/IconCirclePlus.vue";
import { message as validationMessage } from '@/plugins/message'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConciergeQuestion',
  props: {
    modelValue: null,
    categoryId: null,
    sectionId: null
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', question: ConciergeQuestion): void,
  (event: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: ConciergeQuestion
  categoryId: string
  sectionId: string
}



// eslint-disable-next-line func-call-spacing


const keys = ['questionId', 'name', 'question', 'supplement', 'skip', 'processes']
const question = reactive<any>({})
keys.forEach(key => {
  question[key] = computed({
    get() {
      return props.modelValue[key as keyof ConciergeQuestion]
    },
    set(val) {
      emit('update:modelValue', new ConciergeQuestion({ ...props.modelValue, [key]: val}))
    }
  })
})

// 手続き対象の選択肢作成
const processList = ref<any[]>([])
const nicotto = useNicotto()
nicotto.concierge.getProcessList(true)
  .then(data => {
    data.forEach(process => {
      processList.value.push({ name: `【${process.department.displayName()}】${process.name}`, value: process.processId})
    })
  })

// 表示用に担当課リストなどを作成
const departmentList = ref<any[]>([])
const departmentOption = ref<any[]>([])
nicotto.concierge.getDepartmentList()
  .then(data => {
    data.forEach(department => {
      departmentList.value[department.code] = department.name
      departmentOption.value.push({ name: department.displayName(), value: department.code})
    })
  })

// 表示用に手続きIDから手続き名を取得
const getProcessName = (processId: string): string => {
  const process = processList.value.filter((val:{name:"", value:""}) => val.value === processId)
  return process[0] ? process[0].name : ""
}

// 質問の有無により質問タイプを設定
const typeQuestion = ref('no')
const stop = watch(
  () => props.modelValue.question,
  (val) => {
    typeQuestion.value = (val !== '') ? 'yes' : 'no'
    stop()
  }
)

// 質問タイプによって表示内容を変更
const maxProcessLength = ref<number>(1)
const hideClass = ref<boolean>(false)
watch(typeQuestion, () => {
  hideClass.value = (typeQuestion.value === 'no')
  maxProcessLength.value = typeQuestion.value === 'yes' ? Infinity : 1
});

const editDisplay = ref(false)
let editIndex = 0
const editData = ref<ConciergeQuestionProcess>(question.processes[0])
const display = ref<boolean[]>([false])

const addProcess = () => {
  question.processes.push(new ConciergeQuestionProcess());
  display.value.push(false)
}

const deleteProcess = (index:number) => {
  question.processes.splice(index,1);
  display.value.splice(index,1)
}

// 手続き編集のためデータの準備とモーダル表示
const showEditProcess = (index:number) => {
  editData.value = JSON.parse(JSON.stringify(question.processes[index]))
  editIndex = index
  let modalForm:any = document.querySelector('#modal_question');
  modalForm.classList.remove('was-validated')
  editDisplay.value = true;
}

// バリデーション用
const errors = ref<Array<string>[]>([])
let error = []
const processes = ref<ConciergeQuestionProcess[]>([])
const form = ref<HTMLFormElement|null>(null)
const formProcess = ref<InstanceType<any>>()

// 質問全体を登録するときの処理
const submit = () => {
  validateProcessAll()
  if (! useValidateForm(unref(form) as unknown as HTMLFormElement).isValid() || validateProcessAll()) {
    return
  }
  if (typeQuestion.value !== 'yes') {
    if (processes.value.length) {
      processes.value[0].condition = null
    }
    question['question'] = ''
    question['processes'] = processes
  }
  emit('submit')
}
const validateProcessAll = () => {
  errors.value = []
  processes.value = question.processes
  if (typeQuestion.value === 'no') {
    processes.value.splice(1)
  }
  processes.value.forEach((process: ConciergeQuestionProcess) => {
    errors.value.push(getProcessErrorMessage(process))
  });
  if (errors.value.filter(error => error.length).length) {
    return true
  }
}

// 手続きを反映させるときの処理
const updateProcessData = () => {
  if (! useValidateForm(unref(formProcess.value.$el) as unknown as HTMLFormElement).isValid()) {
    return
  }
  question.processes[editIndex] = editData.value
  editDisplay.value = false;
  validateProcessSingle()
}
const validateProcessSingle = () => {
  errors.value[editIndex] = getProcessErrorMessage(question.processes[editIndex])
}

// 手続きの必須項目が空欄であればエラーメッセージを返す
const getProcessErrorMessage = (process: ConciergeQuestionProcess) => {
  error= []
  if (process.processId === '') {
    error.push(validationMessage('concierge.questions.isProcessNull'))
  }
  if (typeQuestion.value === 'yes') {
    if (process.condition == null) {
      error.push(validationMessage('concierge.questions.isConditionNull'))
    }
  }
  return error
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(submit, ["prevent"]),
      ref_key: "form",
      ref: form,
      novalidate: ""
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(FormGroup, {
              label: "種別",
              "label-for": "type",
              class: "border-bottom-0"
            }, {
              default: _withCtx(() => [
                _createVNode(InputText, {
                  label: "種別",
                  id: "type",
                  modelValue: question.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((question.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(FormGroup, {
              label: "質問タイプ",
              required: true,
              class: "border-bottom-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "true",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((typeQuestion).value = $event)),
                    name: "radioType",
                    value: "yes",
                    class: "form-check-input",
                    required: ""
                  }, null, 512), [
                    [_vModelRadio, typeQuestion.value]
                  ]),
                  _hoisted_6
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "false",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((typeQuestion).value = $event)),
                    name: "radioType",
                    value: "no",
                    class: "form-check-input"
                  }, null, 512), [
                    [_vModelRadio, typeQuestion.value]
                  ]),
                  _hoisted_8
                ])
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(FormGroup, {
              label: "質問",
              required: true,
              "label-for": "question",
              class: "border-bottom-0"
            }, {
              default: _withCtx(() => [
                _createVNode(InputTextArea, {
                  label: "質問",
                  id: "question",
                  modelValue: question.question,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((question.question) = $event)),
                  required: typeQuestion.value === 'yes'
                }, null, 8, ["modelValue", "required"])
              ]),
              _: 1
            }, 512), [
              [_vShow, typeQuestion.value === 'yes']
            ]),
            _withDirectives(_createVNode(FormGroup, {
              label: "補足説明",
              "label-for": "description",
              class: "border-bottom-0"
            }, {
              default: _withCtx(() => [
                _createVNode(InputTextArea, {
                  label: "補足説明",
                  id: "description",
                  modelValue: question.supplement,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((question.supplement) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 512), [
              [_vShow, typeQuestion.value === 'yes']
            ]),
            _withDirectives(_createVNode(FormGroup, { label: "回答後のスキップ先" }, {
              default: _withCtx(() => [
                _createVNode(InputSkipSection, {
                  modelValue: question.skip,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((question.skip) = $event)),
                  "category-id": __props.categoryId,
                  "section-id": __props.sectionId
                }, null, 8, ["modelValue", "category-id", "section-id"])
              ]),
              _: 1
            }, 512), [
              [_vShow, typeQuestion.value === 'yes']
            ])
          ])
        ])
      ]),
      _createVNode(_unref(draggable), {
        modelValue: question.processes,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((question.processes) = $event)),
        "item-key": "id",
        handle: ".handle"
      }, {
        item: _withCtx(({ element, index }) => [
          _createElementVNode("div", {
            class: _normalizeClass({ hideProcess:hideClass.value })
          }, [
            (errors.value[index])
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value[index], (message, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "invalid-feedback d-block"
                    }, _toDisplayString(message), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", _hoisted_11, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("button", _hoisted_14, [
                        _createVNode(IconUpDownLeftRight)
                      ], 512), [
                        [_vShow, typeQuestion.value === 'yes']
                      ]),
                      _hoisted_15,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-secondary me-2",
                        onClick: ($event: any) => (showEditProcess(index))
                      }, "編集", 8, _hoisted_16),
                      _createVNode(ButtonDelete, {
                        "dialog-title": "手続きの削除確認",
                        class: "me-3",
                        size: "sm",
                        onDeleteConfirmed: ($event: any) => (deleteProcess(index))
                      }, null, 8, ["onDeleteConfirmed"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-secondary",
                        onClick: ($event: any) => (display.value[index] = !display.value[index])
                      }, [
                        _withDirectives(_createVNode(IconPlus, null, null, 512), [
                          [_vShow, !display.value[index]]
                        ]),
                        _withDirectives(_createVNode(IconMinus, null, null, 512), [
                          [_vShow, display.value[index]]
                        ])
                      ], 8, _hoisted_17)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                _withDirectives(_createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", null, _toDisplayString(element.condition === "yes" ? "はい" : element.condition === "no" ? "いいえ" : ""), 1)
                ], 512), [
                  [_vShow, typeQuestion.value === 'yes']
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_19,
                  _createElementVNode("td", null, _toDisplayString(getProcessName(element.processId)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", null, _toDisplayString(element.name), 1)
                ]),
                _withDirectives(_createElementVNode("tr", null, [
                  _hoisted_21,
                  _createElementVNode("td", null, [
                    (element.belongings)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          innerHTML: element.belongings.replace(/\n/g,'<br/>')
                        }, null, 8, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, display.value[index]]
                ]),
                _withDirectives(_createElementVNode("tr", null, [
                  _hoisted_23,
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.additionalContacts, (additional_window, key) => {
                      return (_openBlock(), _createElementBlock("span", { key: key }, [
                        (key !== 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, ","))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(additional_window) + ":" + _toDisplayString(departmentList.value[additional_window]), 1)
                      ]))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, display.value[index]]
                ]),
                _withDirectives(_createElementVNode("tr", null, [
                  _hoisted_25,
                  _createElementVNode("td", null, [
                    (element.supplement)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          innerHTML: element.supplement.replace(/\n/g,'<br/>')
                        }, null, 8, _hoisted_26))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, display.value[index]]
                ]),
                _withDirectives(_createElementVNode("tr", null, [
                  _hoisted_27,
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.links, (link, link_index) => {
                      return (_openBlock(), _createElementBlock("span", { key: link_index }, [
                        _createElementVNode("b", null, [
                          _createTextVNode(_toDisplayString(link.name), 1),
                          _withDirectives(_createElementVNode("span", null, "：", 512), [
                            [_vShow, link.name]
                          ])
                        ]),
                        _createTextVNode(_toDisplayString(link.url), 1),
                        _hoisted_28
                      ]))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, display.value[index]]
                ]),
                _withDirectives(_createElementVNode("tr", null, [
                  _hoisted_29,
                  _createElementVNode("td", null, [
                    (element.eApplication?.link?.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                          _hoisted_31,
                          _hoisted_32,
                          _createElementVNode("b", null, _toDisplayString(element.eApplication.link.name) + "：", 1),
                          _createTextVNode(_toDisplayString(element.eApplication.link.url), 1),
                          _hoisted_33
                        ]))
                      : _createCommentVNode("", true),
                    (element.eApplication?.supplement)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                          _hoisted_35,
                          _hoisted_36,
                          _createElementVNode("span", {
                            innerHTML: element.eApplication.supplement.replace(/\n/g,'<br/>')
                          }, null, 8, _hoisted_37)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, display.value[index]]
                ]),
                _withDirectives(_createElementVNode("tr", null, [
                  _hoisted_38,
                  _createElementVNode("td", null, [
                    (element.note)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          innerHTML: element.note.replace(/\n/g,'<br/>')
                        }, null, 8, _hoisted_39))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, display.value[index]]
                ])
              ])
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (question.processes.length < maxProcessLength.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-link p-0 add-link",
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (addProcess()))
            }, [
              _createVNode(IconCirclePlus),
              _hoisted_41
            ])
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 40, _hoisted_1),
    _createVNode(ModalWindow, {
      title: "手続き",
      modelValue: editDisplay.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editDisplay).value = $event)),
      size: "xl"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary mx-2 mb-2",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (editDisplay.value = false))
          }, "閉じる"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success mx-2 mb-2",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (updateProcessData()))
          }, "反映")
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(ModalQuestion, {
          modelValue: editData.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editData).value = $event)),
          "process-list": processList.value,
          "department-option": departmentOption.value,
          "type-question": typeQuestion.value,
          ref_key: "formProcess",
          ref: formProcess
        }, null, 8, ["modelValue", "process-list", "department-option", "type-question"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})